// extracted by mini-css-extract-plugin
module.exports = {"main":"styles__main___2TosJ"};